// packages/eden-utilities/src/utils/mergeRefs.js
var mergeRefs = (...refs) => {
  return (node) => {
    for (const ref of refs) {
      if (ref) {
        ref.current = node;
      }
    }
  };
};
var mergeRefs_default = mergeRefs;
export {
  mergeRefs_default as default
};
